import { ReactElement, ReactNode, useCallback, useMemo, useState } from 'react';
import { useParams } from 'react-router';
import ImportCandidateModalContext from './import-candidate-modal-context';
import { ModalTitle } from './types';
import ImportCandidateModal from '@/features/ImportCandidates/ImportCandidateModal';

const ImportCandidateModalProvider = ({ children }: { readonly children: ReactNode }): ReactElement => {
  const [isOpen, setIsOpen] = useState(false);
  const { solutionId } = useParams();
  const modalTitle: ModalTitle = solutionId ? 'Add Candidates' : 'New Solution';

  const openModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  const value = useMemo(
    () => ({ isOpen, openModal, closeModal, modalTitle, solutionId }),
    [isOpen, openModal, closeModal, modalTitle, solutionId],
  );

  return (
    <ImportCandidateModalContext value={value}>
      {isOpen && <ImportCandidateModal />}
      {children}
    </ImportCandidateModalContext>
  );
};

export default ImportCandidateModalProvider;
